import { forwardRef } from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { BidCampaignSelectSkeletonList } from "./BidCampaignSelectLoading";
import { STATUS_FILTERS } from "../lib/constants";
import { BID_V2_COLORS, statusPillSx } from "../lib/bidAutomationStyles";

/**
 * Autocomplete paper with status filters above the listbox.
 * Shows skeleton rows while campaigns are loading.
 */
const BidCampaignSelectPaper = forwardRef(function BidCampaignSelectPaper(
  { activeFilter, onFilterChange, isLoading, children, ...paperProps },
  ref
) {
  return (
    <Paper ref={ref} {...paperProps}>
      <Stack
        spacing={0.75}
        sx={{
          px: 1.5,
          py: 1.25,
          borderBottom: `1px solid ${BID_V2_COLORS.border}`,
          bgcolor: "#FAFBFC",
        }}
        onMouseDown={(e) => e.preventDefault()}
      >
        <Typography
          sx={{
            fontSize: "0.6875rem",
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: BID_V2_COLORS.muted,
          }}
        >
          Filter by status
        </Typography>
        <Stack direction="row" flexWrap="wrap" gap={0.75}>
          {STATUS_FILTERS.map((f) => (
            <Chip
              key={f}
              label={f}
              size="small"
              onMouseDown={(e) => e.preventDefault()}
              onClick={(e) => {
                e.stopPropagation();
                if (f !== activeFilter) onFilterChange?.(f);
              }}
              sx={statusPillSx(activeFilter === f)}
            />
          ))}
        </Stack>
      </Stack>
      {isLoading ? (
        <BidCampaignSelectSkeletonList />
      ) : (
        <Box component="div" sx={{ minWidth: 0 }}>
          {children}
        </Box>
      )}
    </Paper>
  );
});

export default BidCampaignSelectPaper;
